import Minibus from "minibus";

const event_bus = Minibus.create();
export default {
  event_bus: event_bus,
};
